import React, { Fragment, useState } from "react";
import VideoModal from "./VideoModal";

import classes from "./VideoButton.module.css";

const VideoButton = (props) => {
  const [showVideo, setShowVideo] = useState(false);

  const openVideo = () => {
    setShowVideo(true);
  };

  const closeVideo = () => {
    setShowVideo(false);
  };

  const infoMessage = (
    <Fragment>
      <h2>{props.videoTitle}</h2>
      <video className={classes.video} controls>
        <source src={props.video} type="video/mp4" />
      </video>
    </Fragment>
  );

  return (
    <Fragment>
      {showVideo && (
        <VideoModal modalHandler={closeVideo} infoMessage={infoMessage} />
      )}
      <div className={classes.container}>
        <button type="button" className={classes.button} onClick={openVideo}>
          <p>Need help with what you see here?</p>
          <p>Click here to watch an explanatory video</p>
        </button>
      </div>
    </Fragment>
  );
};

export default VideoButton;
